import api from "../service";
import { ApiResponse } from "apisauce";
import { Dispatch } from "redux";
import { theme, theme_marcados } from "data";
import { hotToast, messagesLevel } from "utils";

const handleAuthLoginValidationFor39 = (res: ApiResponse<any>) => {
  if (!res.ok) {
    hotToast(res?.data.message || "Error response!", "ERROR");

    return null;
  }
  if (res.status !== 200) {
    hotToast("Error response Status!" + res.status, "ERROR");
    return null;
  }
  const { code, data, message } = res.data;
  if (code !== 0) {
    hotToast(message || "Error response!", "ERROR");
    return null;
  }
  if (data === null) {
    hotToast(message || "Error Auth!", "ERROR");
    return null;
  }
  return data;
};

export const requestAuth =
  (user: string, password: string) => async (dispatch: Dispatch) => {
    let _object = { user, password, idAplicacion: 39, idOrigen: 1 };
    let data = btoa(JSON.stringify(_object));
    await api.removeToken();
    let isValid: object | any | null = await api
      .requestPost(`Auth`, { data })
      .then(handleAuthLoginValidationFor39)
      .catch((err) => {
        hotToast(messagesLevel("network"), "ERROR");
        return null;
      });

    if (isValid) {
      await dispatch({
        type: "LOG_IN",
        payload: isValid,
      });
      if (isValid.additional) {
        dispatch({
          type: "SET_JWT",
          payload: isValid,
        });

        dispatch({
          type: "SET_THEME",
          payload: {
            theme: isValid?.additional.estilo
              ? JSON.parse(isValid?.additional.estilo)
              : theme,
            modo: isValid?.additional.modo ? isValid?.additional.modo : "claro",
          },
        });
      }
    }

    return isValid ? true : false;
  };

export const requestAuthAmbientes =
  (idUsuario: string, ambiente: string, token: string, fullname: string) =>
  async (dispatch: Dispatch) => {
    let _object = {
      idUsuarioAct: idUsuario,
      idAmbiente: ambiente,
      token: token,
    };
    let data = btoa(JSON.stringify(_object));
    let isValid: object | any | null = await api
      .requestPost(`Auth`, {
        data: data,
        isAmbient: true,
        idUsuario: idUsuario,
        fullName: fullname,
        tokenSeguridad: token,
      })
      .then(handleAuthLoginValidationFor39)
      .catch((err) => {
        hotToast(messagesLevel("network"), "ERROR");
        return null;
      });
    if (isValid) {
      dispatch({
        type: "SET_JWT",
        payload: isValid,
      });
      dispatch({
        type: "SET_AMB",
        payload: ambiente,
      });
      dispatch({
        type: "SET_THEME",
        payload: {
          theme: isValid?.additional.estilo
            ? JSON.parse(isValid?.additional.estilo)
            : theme,
          modo: isValid?.additional.modo ? isValid?.additional.modo : "claro",
        },
      });
    }

    return isValid ? true : false;
  };

export const exampleRequestJwt = async () => {
  await api.setToken();
};

export const authLoginByToken =
  (token: string, key: string) => async (dispatch: Dispatch) => {
    await api.removeToken();
    let isValid: object | any | null = await api
      .requestPost(`/auth/automatic-login`, { token, key })
      .then(handleAuthLoginValidationFor39)
      .catch((err) => {
        hotToast(messagesLevel("network"), "ERROR");
        return null;
      });

    if (isValid) {
      await dispatch({
        type: "LOG_IN",
        payload: isValid,
      });
      if (isValid.additional) {
        dispatch({
          type: "SET_JWT",
          payload: isValid,
        });

        dispatch({
          type: "SET_THEME",
          payload: {
            theme: isValid?.additional.estilo
              ? JSON.parse(isValid?.additional.estilo)
              : theme,
            modo: isValid?.additional.modo ? isValid?.additional.modo : "claro",
          },
        });
      }
    }

    return isValid ? true : false;
  };
